/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  paymetirc-reducer.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date         : Sep 19, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali
 * On            : Sep 19 2019
 * Description   : ASDS-165
 *
 * By            : Deepthi Bachu
 * On            : Sep 25 2019
 * Description   : ASDS-1285
 ******************************************************************************/

import Reducer from './reducer';
import CheckoutActionConstants from "../../constants/checkoutActionConstants";
import { createReducer } from "../utils/redux-util";
import { AsdsReducerObject, AsdsReduxAction } from "../../../../types";
import { logInfo } from '../../../../utils/console-utility';

class PaymetricReducer extends Reducer {

    static getPaymetricURL(state, _action: AsdsReduxAction): AsdsReducerObject {
        logInfo('in paymetric getURL reducer', state);
        return {
            ...state,
            isSuccess: true,
            isFetching: true,
            isError: false,
            payload: {}
        };
    }

    static setPaymetricURL(state, action: AsdsReduxAction): AsdsReducerObject {
        logInfo('in paymetric getURL reducer', state);
        return {
            ...state,
            isSuccess: true,
            isFetching: false,
            payload: action.payload.response,
        };
    }
    /**
     * Jira ID:ASDS-1285
     * @description: updates the count value in store for CC Section Loading
     *
     * @param state
     * @param action
     */
    static updateCCLoadCount(state, action: AsdsReduxAction) {
        return {
            ...state,
            count: action.payload.count,
        };
    }

    /**
     * Jira ID:ASDS-1285
     * @description: updates the count value to 0 in store for CC Section Loading
     *
     * @param state
     * @param action
     */
    // static resetCCLoadCount(state, action: AsdsReduxAction) {
    //     return {
    //         ...state,
    //         count: action.payload.count,
    //     }
    // }

    /**
     * ASDS-1476
     * @description updates isError status in reducer.
     * @param _state
     * @param action
     */
    static hasError(_state, action: AsdsReduxAction) {
        const status = action.payload.response;
        return {
            isError: status,
        };
    }

}

const handlers = {
    [CheckoutActionConstants.GET_PAYMETRIC_URL]: PaymetricReducer.getPaymetricURL,
    [CheckoutActionConstants.SET_PAYMETRIC_URL]: PaymetricReducer.setPaymetricURL,
    [CheckoutActionConstants.INCREMENT_CC_LOAD_COUNT]: PaymetricReducer.updateCCLoadCount,
    [CheckoutActionConstants.RESET_CC_LOAD_COUNT]: PaymetricReducer.updateCCLoadCount,
    [CheckoutActionConstants.HAS_ERROR]: PaymetricReducer.hasError,
};

const initialState = {
    isSuccess: false,
    isFetching: false,
    isError: false,
    payload: {
        embedIframeUrl: '',
        signedPayload: '',
        accessToken: '',
    },
    count: 0,
};

export const paymetricData = createReducer(initialState, handlers);